import { Injectable } from '@angular/core';
import { IConfig } from '../models/agency-config';

@Injectable({
  providedIn: 'root',
})
export class FontService {
  applyFonts(fonts: IConfig['fonts']) {
    const fontKeys = [
      { name: 'default_font', file: 'default_font_file' },
      { name: 'bot_title_font', file: 'bot_title_font_file' },
      { name: 'chat_menu_font', file: 'chat_menu_font_file' }
    ];

    const style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = `
      :root {
        --default-font: '${fonts.default_font}';
        --bot-title-font: '${fonts.bot_title_font}';
        --chat-menu-font: '${fonts.chat_menu_font}';
      }
    `;
    document.head.appendChild(style);


fontKeys.forEach((key) => {
  const fontFamily = fonts[key.name as keyof typeof fonts];
  const fontUrl = fonts[key.file as keyof typeof fonts];

  if (!fontUrl) return;

  const fontUrlStr = String(fontUrl);

  if (fontUrlStr.includes('fonts.googleapis.com')) {
    if (!document.querySelector(`link[href="${fontUrlStr}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = fontUrlStr;
      document.head.appendChild(link);
    }
  } else {
    const fontFace = document.createElement('style');
    fontFace.type = 'text/css';
    fontFace.innerHTML = `
      @font-face {
        font-family: '${fontFamily}';
        src: url('${fontUrlStr}');
      }
    `;
    document.head.appendChild(fontFace);
  }
});
  }
}
